import { FinishActiveSearchers } from 'domain/usecases/surgical-order-cancellation/finish-active-searcher'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteFinishActiveSearchers implements FinishActiveSearchers {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  finish(params: FinishActiveSearchers.Params) {
    return this.surgicalOrderRepository.finishActiveSearchers(params)
  }
}
